export default __webpack_public_path__ + "static/media/imageonbusinesspart.a9eddb3d.svg";